import styled from '@emotion/styled'

export const FooterWrapper = styled.div`
  text-align: center;
`
